function Field({ label, value }) {
  return (
    <div className="flex flex-col">
      <span className="text-xs text-zinc-500">{label}</span>
      <span className="font-medium">{value ?? "-"}</span>
    </div>
  );
}

export default Field;
